import { render, staticRenderFns } from "./ActivityTreeNodeBookmarksQrCodeExport.global.vue?vue&type=template&id=2735bc05&lang=pug&"
import script from "./ActivityTreeNodeBookmarksQrCodeExport.global.vue?vue&type=script&lang=ts&"
export * from "./ActivityTreeNodeBookmarksQrCodeExport.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports